var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-12",attrs:{"grid-list-xs":""}},[_c('h1',[_vm._v("Dashboard")]),_c('v-layout',{attrs:{"row":"","wrap":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }